import React from "react";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import { useTranslation } from "react-i18next";

const SERVICE_KEYS = ["s1", "s2", "s3", "s4", "s5"];
const SERVICE_ITEM_COUNTS = { s1: 5, s2: 5, s3: 4, s4: 4, s5: 3 };

const Service = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO title="Our Services - Cyberate Investments | Investment & Commercial Decision Intelligence" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

        <section className="dddi-section">
          <div className="container">
            <div className="dddi-section-head">
              <span className="dddi-eyebrow">{t("dddi.services.subtitle")}</span>
              <h1 className="dddi-title">{t("dddi.services.title")}</h1>
              <p className="dddi-lede">{t("dddi.services.intro1")}</p>
              <p className="dddi-lede" style={{ marginTop: 12 }}>
                {t("dddi.services.intro2")}
              </p>
            </div>

            <div className="dddi-service-list">
              {SERVICE_KEYS.map((key) => (
                <div key={key} className="dddi-service">
                  <div className="dddi-service-head">
                    <h3 className="dddi-service-title">
                      {t(`dddi.services.${key}.title`)}
                    </h3>
                    <span className="dddi-chip">
                      {t(`dddi.services.${key}.dddi`)}
                    </span>
                  </div>
                  <ul>
                    {Array.from({ length: SERVICE_ITEM_COUNTS[key] }).map(
                      (_, i) => (
                        <li key={i}>{t(`dddi.services.${key}.items.${i}`)}</li>
                      )
                    )}
                  </ul>
                  {key === "s3" && (
                    <p className="dddi-service-note">
                      {t("dddi.services.s3.note")}
                    </p>
                  )}
                </div>
              ))}

              {/* Own capital participation */}
              <div className="dddi-service">
                <div className="dddi-service-head">
                  <h3 className="dddi-service-title">
                    {t("dddi.services.own_capital.title")}
                  </h3>
                </div>
                <p className="dddi-card-text">
                  {t("dddi.services.own_capital.content")}
                </p>
              </div>
            </div>

            {/* Full compliance statement */}
            <div className="dddi-compliance" style={{ marginTop: 56 }}>
              <span className="dddi-eyebrow">{t("dddi.compliance.title")}</span>
              <p>{t("dddi.compliance.full")}</p>
            </div>
          </div>
        </section>

        <FooterTwo />
      </main>
    </>
  );
};

export default Service;
